import React, { useEffect, useState } from "react";
import edite_img from "../../../assets/images/man_two.jpg";
import { Col, Row } from "reactstrap";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router";
import { decryptData } from "../../../utils/helper";
import "../Applications.css";
import { getStatusIcon } from "../../../utils/messageStatusIcon";

const AddText = ({ application, setIsComposeText }) => {
  const user = useSelector((state) => state.userReducer.user);
  const navigate = useNavigate();
  const [activeNumber, setActiveNumber] = useState(null);

  const patientPhone = application?.patientData?.telecom?.find(obj => obj.system === "homePhone");
  const patientPhoneNumber = patientPhone ? decryptData(patientPhone.value) : null;

  useEffect(() => {
    if (patientPhoneNumber) setActiveNumber(patientPhoneNumber);
  }, [patientPhoneNumber]);

  const renderMessageText = (encryptedMsg) => {
    const decryptedMsg = encryptedMsg && decryptData(encryptedMsg);
    const urlPattern = /^(https?:\/\/[^\s]+)$/i;

    return urlPattern.test(decryptedMsg) ? (
      <a href={decryptedMsg} target="_blank" rel="noopener noreferrer" style={{ color: "#007bff" }}>
        {decryptedMsg}
      </a>
    ) : (
      <span>{decryptedMsg}</span>
    );
  };

  const renderAttachments = (attachments = []) =>
    attachments.map((attachment, index) => {
      const url = attachment.signedUrl;
      const fileName = url.split("/").pop().split("?")[0];
      const extension = fileName.split(".").pop().toLowerCase();
      const isImage = ["jpeg", "jpg", "png", "gif", "bmp", "webp"].includes(extension);
      const isPDF = extension === "pdf";

      return (
        <div key={index} style={{ margin: "10px", textAlign: "center" }}>
          {isImage ? (
            <img src={url} alt={fileName} style={{ height: "150px", width: "150px", borderRadius: "5px", objectFit: "cover" }} />
          ) : (
            <div>
              <i
                className={`fa-solid ${isPDF ? "fa-file-pdf" : "fa-file"}`}
                style={{ fontSize: "48px", color: isPDF ? "#d9534f" : "#999" }}
              ></i>
            </div>
          )}
          <div style={{ marginTop: "5px", fontSize: "14px", maxWidth: "150px", overflowWrap: "break-word" }}>{fileName}</div>
          <a href={url} download={fileName} title="Download" style={{ display: "inline-block", marginTop: "5px" }}>
            <i className="fa fa-download"></i> Download
          </a>
        </div>
      );
    });

  const renderMessage = (message, index) => {
    const isOutgoing = message.direction === "outgoing";

    return (
      <Row
        key={index}
        className={`align-items-start mb-5 ${isOutgoing ? "second_message" : ""}`}
      >
        {!isOutgoing && (
          <Col md={2}>
            <img src={edite_img} alt="Profile" className="edite_img" />
          </Col>
        )}
        <Col md={10}>
          <div className="messages_block">
            <p>{renderMessageText(message?.msg)}</p>
            {message?.attachments?.length > 0 && (
              <div className="attachments-container" style={{ display: "flex", flexWrap: "wrap" }}>
                {renderAttachments(message.attachments)}
              </div>
            )}
            <div className="timestamp d-flex align-items-center justify-content-end gap-2">
            {isOutgoing && (
                <i
                  className={`fa ${getStatusIcon(message.status).icon}`}
                  title={message.status}
                  style={{ marginLeft: "10px", color: getStatusIcon(message.status).color, fontSize: "16px" }}
                ></i>
              )}
              <span>{moment(message.createdAt).format("MMM DD, h:mm A")}</span>
            </div>
          </div>
        </Col>
        {isOutgoing && (
          <Col md={2} className="d-flex justify-content-end">
            <img
              src={edite_img}
              alt="Profile"
              className="edite_img"
            />
          </Col>
        )}
      </Row>
    );
  };

  const filteredMessages = application?.messages || [];

  return (
    <div className="add_text_container">
      <div className="d-flex gap-2 add_text_head">
        <div className="messages_blkk">
          <div className="second_blkk number_item">
            <img src={edite_img} alt="" className="img_blockk" />
            <p className="name_blkk">{patientPhoneNumber}</p>
            <div className="edit_access">
            <i className="fa fa-edit" onClick={() => setIsComposeText(true)}></i>
          </div>
          </div>
          </div>
        <div className="patient_portal_block">
          <div className="profile_chat">
            <Row>
              <Col md={12}>
                {filteredMessages.length > 0 ? (
                  filteredMessages.map(renderMessage)
                ) : (
                  <div className="messages_block d-flex justify-content-center pb-4">
                    <b>No Messages</b>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddText;
